import { render, staticRenderFns } from "./BusinessSearch.vue?vue&type=template&id=a4ccc464&scoped=true&"
import script from "./BusinessSearch.vue?vue&type=script&lang=js&"
export * from "./BusinessSearch.vue?vue&type=script&lang=js&"
import style0 from "./BusinessSearch.vue?vue&type=style&index=0&id=a4ccc464&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4ccc464",
  null
  
)

export default component.exports